import Swiper, {Autoplay, EffectFade} from 'swiper';

Swiper.use([Autoplay, EffectFade]);

const selectors = {
  slider: '.js-hero-slider',
};

const heroSlider = () => {
  const container = document.querySelector(selectors.slider);

  if (!container) return;

  const slider = new Swiper(container, {
    slidesPerView: 1,
    effect: 'fade',

    autoplay: {
      delay: 7000,
    },
  });

  return slider;
};

export default heroSlider;
